// Empêche les liens "#" du footer de scroller en haut
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.footer__link-list-item a[href="#"]').forEach(a => {
    a.addEventListener('click', e => e.preventDefault());
  });
});

// Gestion responsive du footer (mobile < 768px)
(function () {
  const mq = window.matchMedia('(max-width: 767.98px)');

  function allLists() { return Array.from(document.querySelectorAll('.footer__link-list-item ul')); }

  function onItemClick(e) {
    const li = e.target.closest('.footer__link-list-item');
    if (!li) return;
    allLists().forEach(ul => { ul.style.display = 'none'; });
    const own = li.querySelector('ul');
    if (own) own.style.display = 'block';
  }

  function toMobile() {
    allLists().forEach(ul => { ul.style.display = 'none'; });
    document.addEventListener('click', onItemClick);
  }

  function toDesktop() {
    allLists().forEach(ul => { ul.style.display = 'block'; });
    document.removeEventListener('click', onItemClick);
  }

  function apply() {
    if (mq.matches) toMobile();
    else toDesktop();
  }

  document.addEventListener('DOMContentLoaded', apply);
  mq.addEventListener('change', apply);
  window.addEventListener('resize', apply);
})();

// Hash URL : remonte en haut immédiatement puis scrolle en douceur
if (window.location.hash) {
  setTimeout(() => window.scrollTo(0, 0), 1);
}

window.addEventListener('load', function () {
  if (!window.location.hash) return;
  const target = document.querySelector(window.location.hash);
  if (target) {
    window.scrollTo({ top: target.getBoundingClientRect().top + window.pageYOffset - 100, behavior: 'smooth' });
  }
});
